import { ApiError, InternalError, RequestError } from "redux-api-middleware";

export type reduxApiMiddlewareError = InternalError | RequestError | ApiError;

export interface Campaign {
  id: string;
  type: string;
  code: string;
  causedPart: string;
  status: boolean;
  description: string;
  descriptionDetailed: string;
}

interface Campaigns extends ReadonlyArray<Campaign> {}

export interface State {
  campaigns?: Campaigns;
  loading: Boolean;
  error?: reduxApiMiddlewareError;
}

interface Attributes {
  code: string;
  status: boolean;
  description: string;
  "description-detailed": string;
  "caused-part": string;
}

interface DataItem {
  type: string;
  id: string;
  attributes: Attributes;
}

interface Data extends ReadonlyArray<DataItem> {}

interface SuccessResponce {
  data: Data;
}

export const CAMPAIGNS_REQUEST = "CAMPAIGNS_REQUEST";
export const CAMPAIGNS_SUCCESS = "CAMPAIGNS_SUCCESS";
export const CAMPAIGNS_FAILURE = "CAMPAIGNS_FAILURE";
export const CAMPAIGNS_RESET = "CAMPAIGNS_RESET";

interface RequestCampaignsAction {
  type: typeof CAMPAIGNS_REQUEST;
}

interface SuccessCampaignsAction {
  type: typeof CAMPAIGNS_SUCCESS;
  payload: SuccessResponce;
}

interface FailureCampaignsAction {
  type: typeof CAMPAIGNS_FAILURE;
  payload: reduxApiMiddlewareError;
}

export type CampaignsActionTypes = RequestCampaignsAction | SuccessCampaignsAction | FailureCampaignsAction;
